import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Add, Assessment, PictureAsPdf, DirectionsCar, Build, LocalGasStation, Sync } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { analysisReportColumnData } from "../../common/constants/gridRowColumn";
import { useAnalysis, useCompany, useUser, useFuelAnalysis } from "../../common/hooks";
import { AdminPageStyle } from "./style";
import {
  ensureHeaderTooltip,
  getCompanyId,
  getDefaultColDef,
  sidebarMenu,
} from "../../common/constants/commonFunction";
import { useForm } from "react-hook-form";
import {
  addComma,
  getCurrencyValue,
  removeCommaAndRemoveCurrency,
  removeCurrency,
} from "../../common/services/number-service";
import { DEALEAR_DEFAULT } from "../../common/constants/dealer-name";
import { TruckLoader } from "../../pages/admin/truckLoader";
import { handleExportButton } from "../../common/services/exportPowerBI";
import { handleExportToPDF } from "../../common/services/exportPowerBIPdf";
import { handleExportToCSV, handleExportToPPT } from "../../common/services/analysisExportService";
import { ConfirmAnalysisResultDialog } from "../../components/ConfirmAnalysisDialog";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TableViewIcon from "@mui/icons-material/TableView";
import GridOnIcon from "@mui/icons-material/GridOn";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const PremiumCard = ({ title, icon, children }) => (
  <Box sx={{
    background: "var(--surface)", border: "1px solid var(--divider)", borderRadius: "16px",
    boxShadow: "0 4px 16px rgba(8,96,211,0.06)", display: "flex", flexDirection: "column",
    overflow: "hidden", height: "100%", transition: "transform 0.2s, box-shadow 0.2s",
    "&:hover": { transform: "translateY(-2px)", boxShadow: "0 8px 24px rgba(8,96,211,0.12)", borderColor: "rgba(8,96,211,0.3)" }
  }}>
    <Box sx={{ px: 2, py: 1.5, borderBottom: "1px solid var(--divider)", background: "rgba(8,96,211,0.03)", display: "flex", alignItems: "center", gap: 1.5 }}>
      {icon}
      <span style={{ fontSize: 13, fontWeight: 800, color: "var(--brand-primary)", letterSpacing: "0.5px" }}>{title}</span>
    </Box>
    <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1.5, flex: 1 }}>
      {children}
    </Box>
  </Box>
);

const MetricRow = ({ label, value }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px dashed var(--divider)", pb: 1 }}>
    <span style={{ fontSize: 12, fontWeight: 500, color: "var(--text-secondary)" }}>{label}</span>
    <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text-primary)" }}>{value}</span>
  </Box>
);

export const AnalysisResults1 = () => {
  const classes = AdminPageStyle();
  const { state } = useLocation();
  const [reportDataFleet, setReportDataFleet] = useState();
  const [rowData, setRowData] = useState([]);
  const [cyclingComparision, setCyclingComparision] = useState();
  const [proposedCycle, setProposedCycle] = useState();
  const [fuelCost, setFuelCost] = useState();
  const [maintananceCost, setMaintananceCost] = useState();
  const [totalSavings, setTotalSavings] = useState(0);
  const [timeoutId, setTimeoutId] = useState(null);
  const navigation = useNavigate();
  const {
    updateAnalysisResult,
    loading,
    setAnalysisResultId,
    analysisResult,
    updateViewAnalysisResult,
    getAnalysisResultByIdApi,
    analysisResultId,
    popupOpen,
    setPopupOpen,
    analysisCompanyChange,
    setAnalysisCompanyChange,
    analysisDealerChange,
    setAnalysisDealerChange,
    analysisCompanyNameChange,
    setAnalysisCompanyNameChange,
    analysisDealerNameChange,
    setAnalysisDealerNameChange,
    setAnalysisDealerDefaultNameChange,
    setAnalysisCompanyDefaultNameChange,
    updateAnalysisCompanyResult,
  } = useAnalysis();
  const {
    companyNameHeader,
    setDealerNameHeader,
    setCompanyNameHeader,
    dealerNameHeader,
  } = useCompany();
  const { setSelectedNav } = useUser();
  const { getFuelAnalysisApiList } = useFuelAnalysis();
  const userType = localStorage.getItem("type");
  const localUserId = localStorage.getItem("userID");
  const companyId = getCompanyId(userType, companyNameHeader);
  const { register, handleSubmit, reset, setValue } = useForm({});
  const defaultColDef = useMemo(() => getDefaultColDef(), []);
  const [reportDataFinal, setReportDataFinal] = useState();
  const [data, newData] = useState([]);
  const [loadingGrid, setLoadingGrid] = useState(false);
  const [loadingDilogBoxSave, setLoadingDilogBoxSave] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const repairFuelIfNeeded = async (reportData, reportObj) => {
    if (!reportData) return;
    const currentMix = reportData?.fleetMix || [];
    const isFuelEmpty =
      currentMix.length === 0 ||
      currentMix.every((r) => {
        const val = Number(removeCurrency(r?.fuel));
        return isNaN(val) || val === 0;
      });
    const isFuelCostEmpty =
      !reportData?.fuelCost ||
      Number(removeCurrency(reportData?.fuelCost?.totalFuelSpend)) === 0;

    if (!isFuelEmpty && !isFuelCostEmpty) return;

    const targetCompanyId =
      reportData?.fleet?.companyId ||
      reportObj?.companyId ||
      state?.data?.companyId ||
      companyId;
    if (!targetCompanyId) return;

    const activeDealerId = dealerNameHeader?.id ?? DEALEAR_DEFAULT.dealerId;
    let fuelRes = await getFuelAnalysisApiList({
      fleetNo: "",
      companyId: targetCompanyId,
      dealerId: activeDealerId,
      userId: localUserId,
    });

    let fuelRows = Array.isArray(fuelRes?.data)
      ? fuelRes.data
      : Array.isArray(fuelRes?.data?.data)
        ? fuelRes.data.data
        : Array.isArray(fuelRes)
          ? fuelRes
          : [];

    if (!fuelRows.length && activeDealerId !== DEALEAR_DEFAULT.dealerId) {
      const fallbackRes = await getFuelAnalysisApiList({
        fleetNo: "",
        companyId: targetCompanyId,
        dealerId: DEALEAR_DEFAULT.dealerId,
        userId: localUserId,
      });
      fuelRows = Array.isArray(fallbackRes?.data)
        ? fallbackRes.data
        : Array.isArray(fallbackRes?.data?.data)
          ? fallbackRes.data.data
          : Array.isArray(fallbackRes)
            ? fallbackRes
            : [];
    }

    if (fuelRows && fuelRows.length > 0) {
      let fuelSumCurrent = 0;
      let fuelSumY1 = 0;
      let fuelSumY2 = 0;
      let fuelSumY3 = 0;
      let fuelSumY4 = 0;
      let fuelSumY5 = 0;
      let sumOrigMpg = 0;
      let sumCyclingMpg = 0;
      let sumFuelPrice = 0;
      let sumForecasted = 0;

      fuelRows.forEach((item) => {
        sumOrigMpg += Number(item.originalFuelEconomy || item.OriginalFuelEconomy || 0);
        sumCyclingMpg += Number(item.cyclingFuelEconomy || item.CyclingFuelEconomy || item.originalFuelEconomy || 0);
        sumFuelPrice += removeCommaAndRemoveCurrency(item.averageFuelPrice || item.AverageFuelPrice);
        sumForecasted += removeCommaAndRemoveCurrency(item.annualFuelSpendForecasted || item.AnnualFuelSpendForecasted);

        const cur =
          removeCommaAndRemoveCurrency(item.annualFuelCostCurrent || item.AnnualFuelCostCurrent) ||
          removeCommaAndRemoveCurrency(item.anticipatedFuelCostCurrent || item.AnticipatedFuelCostCurrent);
        const y1 =
          removeCommaAndRemoveCurrency(item.annualFuelCostYear1 || item.AnnualFuelCostYear1) ||
          removeCommaAndRemoveCurrency(item.anticipatedFuelCostYear1 || item.AnticipatedFuelCostYear1);
        const y2 =
          removeCommaAndRemoveCurrency(item.annualFuelCostYear2 || item.AnnualFuelCostYear2) ||
          removeCommaAndRemoveCurrency(item.anticipatedFuelCostYear2 || item.AnticipatedFuelCostYear2);
        const y3 =
          removeCommaAndRemoveCurrency(item.annualFuelCostYear3 || item.AnnualFuelCostYear3) ||
          removeCommaAndRemoveCurrency(item.anticipatedFuelCostYear3 || item.AnticipatedFuelCostYear3);
        const y4 =
          removeCommaAndRemoveCurrency(item.annualFuelCostYear4 || item.AnnualFuelCostYear4) ||
          removeCommaAndRemoveCurrency(item.anticipatedFuelCostYear4 || item.AnticipatedFuelCostYear4);
        const y5 =
          removeCommaAndRemoveCurrency(item.annualFuelCostYear5 || item.AnnualFuelCostYear5) ||
          removeCommaAndRemoveCurrency(item.anticipatedFuelCostYear5 || item.AnticipatedFuelCostYear5);

        fuelSumCurrent += cur;
        fuelSumY1 += y1;
        fuelSumY2 += y2;
        fuelSumY3 += y3;
        fuelSumY4 += y4;
        fuelSumY5 += y5;
      });

      const fleetCount = reportData?.fleet?.currentFleetSize || fuelRows.length || 1;
      const avgMiles = reportData?.fleet?.annualMiles || (fuelRows[0]?.annualMileage || 0);

      const updatedFuelCost = {
        avgMpg: sumOrigMpg > 0 ? (sumOrigMpg / fuelRows.length) : (reportData?.fuelCost?.avgMpg || 0),
        avgAnnualMiles: avgMiles,
        numberOfVehicle: fleetCount,
        costPerGallon: sumFuelPrice > 0 ? (sumFuelPrice / fuelRows.length) : (reportData?.fuelCost?.costPerGallon || 0),
        totalFuelSpend: fuelSumCurrent,
        annualSpendVehicle: fuelSumCurrent / fleetCount,
        monthlySpendVehicle: (fuelSumCurrent / fleetCount) / 12,
        companyId: targetCompanyId,
        dealerId: activeDealerId,
      };
      setFuelCost(updatedFuelCost);

      const updatedCycling = {
        ...(reportData?.cyclingComparision || {}),
        avgYear1Mpg: sumCyclingMpg > 0 ? (sumCyclingMpg / fuelRows.length) : (reportData?.cyclingComparision?.avgYear1Mpg || 0),
        fuelSpendY1: sumForecasted > 0 ? (sumForecasted / fleetCount) : (fuelSumY1 / fleetCount),
      };
      setCyclingComparision(updatedCycling);

      const fuelValues = [fuelSumCurrent, fuelSumY1, fuelSumY2, fuelSumY3, fuelSumY4, fuelSumY5];
      const sourceMix = (reportData?.fleetMix && reportData.fleetMix.length > 0) ? reportData.fleetMix : currentMix;
      const updatedMix = sourceMix.map((row, idx) => {
        const fuelVal = fuelValues[idx] || 0;
        const cashOutlay = Number(removeCurrency(row.cashOutlay)) || 0;
        const currentPayment = Number(removeCurrency(row.currentPayment)) || 0;
        const cyclingPayment = Number(removeCurrency(row.cyclingPayment)) || 0;
        const maintenance = Number(removeCurrency(row.maintenance)) || 0;
        const vehicleEquity = Number(removeCurrency(row.vehicleEquity)) || 0;
        const fleetSpeed = cashOutlay + currentPayment + cyclingPayment + maintenance + fuelVal;
        return {
          ...row,
          cashOutlay: removeCurrency(row.cashOutlay),
          currentPayment: removeCurrency(row.currentPayment),
          cyclingPayment: removeCurrency(row.cyclingPayment),
          vehicleEquity: removeCurrency(row.vehicleEquity),
          maintenance: removeCurrency(row.maintenance),
          fuel: fuelVal,
          fleetSpeed: fleetSpeed,
        };
      });

      const baseFleetSpeed = updatedMix[0]?.fleetSpeed || 0;
      updatedMix.forEach((row, idx) => {
        const vehicleEquity = Number(removeCurrency(row.vehicleEquity)) || 0;
        row.savings = idx === 0 ? 0 : parseFloat((baseFleetSpeed - row.fleetSpeed + vehicleEquity).toFixed(2));
      });

      setRowData(updatedMix);
      const total = updatedMix.reduce((acc, row) => acc + (row.savings || 0), 0);
      setTotalSavings(parseFloat(total.toFixed(2)));

      const newReportDataObj = {
        fleet: reportData?.fleet || reportDataFleet,
        maintainanceCost: reportData?.maintainanceCost || maintananceCost,
        fuelCost: updatedFuelCost,
        cyclingComparision: updatedCycling,
        fleetMix: updatedMix,
      };
      const newReportDataStr = JSON.stringify(newReportDataObj);
      setReportDataFinal((prev) => ({
        ...(prev || reportObj),
        reportData: newReportDataStr,
      }));

      const reportId = reportObj?.id || state?.data?.id;
      if (reportId) {
        updateAnalysisResult({
          reportData: newReportDataStr,
          companyId: targetCompanyId,
          createdBy: Number(localStorage.getItem("cashflow_admin_user_id")),
          id: reportId,
          reportName: reportObj?.reportName || state?.data?.reportName,
          createdAt: moment().format(),
        });
      }
    }
  };

  useEffect(() => {
    if (state?.data) {
      if (state.data.reportData) {
        let reportData = JSON.parse(state.data.reportData);
        setReportDataFleet(reportData?.fleet);
        setCyclingComparision(reportData?.cyclingComparision);
        setProposedCycle(reportData?.cyclingComparision?.proposedCycle || 0);
        setRowData(reportData?.fleetMix);
        setFuelCost(reportData?.fuelCost);
        setMaintananceCost(reportData?.maintainanceCost);
        setReportDataFinal(state.data);
        repairFuelIfNeeded(reportData, state.data);
      }
      if (state?.data?.id) {
        getAnalysisResultByIdApi(state.data.id);
      }
    }
  }, [state]);

  useEffect(() => {
    if (analysisResultId) {
      let reportData = JSON.parse(analysisResultId.reportData);
      setReportDataFleet(reportData?.fleet);
      setCyclingComparision(reportData?.cyclingComparision);
      setProposedCycle(reportData?.cyclingComparision?.proposedCycle || 0);
      setRowData(reportData?.fleetMix);
      setFuelCost(reportData?.fuelCost);
      setMaintananceCost(reportData?.maintainanceCost);
      setReportDataFinal(analysisResultId);
      repairFuelIfNeeded(reportData, analysisResultId);
    }
  }, [analysisResultId]);

  const calculateTotalSavings = (data) => {
    const total = data.reduce((acc, row) => acc + (row.savings || 0), 0);
    setTotalSavings(parseFloat(total.toFixed(2)));
  };

  useEffect(() => {
    if (state?.data) {
      if (data?.length > 0) {
        if (rowData.length > 0) {
          const updatedRowData = [...rowData];
          for (let i = 0; i < rowData.length; i++) {
            updatedRowData[0].cashOutlay =
              reportDataFleet?.avgNewVehiclePrice?.toFixed(2) *
              updatedRowData[0].purchasedFinancial;
            updatedRowData[0].fleetSpeed =
              updatedRowData[0].cashOutlay +
              updatedRowData[0].fuel +
              updatedRowData[0].maintenance +
              updatedRowData[0].cyclingPayment +
              updatedRowData[0].currentPayment;
            updatedRowData[i].savings =
              updatedRowData[0].fleetSpeed -
              updatedRowData[i].fleetSpeed +
              updatedRowData[i].vehicleEquity;
            setRowData(updatedRowData);
            calculateTotalSavings(updatedRowData);
          }
        }
      }
    }
  }, [state?.data, rowData.length, data]);

  useEffect(() => {
    if (state?.data) {
      if (rowData.length > 0) {
        const updatedRowData = [...rowData];
        console.log('updatedRowData', updatedRowData)
        updatedRowData[0].purchasedFinancial = updatedRowData[0].purchasedFinancial;

        setRowData(updatedRowData);
        calculateTotalSavings(updatedRowData);
      }
    }
  }, [state?.data, rowData.length]);

  const handleCellValueChange = (event, value) => {
    const updatedRowData = [...rowData];
    const rowIndex = event.rowIndex;
    if (event.colDef.field == "purchasedFinancial") {
      if (rowIndex !== 0) {
        updatedRowData[rowIndex].cyclingPayment = parseFloat(
          (
            cyclingComparision?.monthlyLeaseCost?.toFixed(2) *
            updatedRowData[rowIndex].purchasedFinancial *
            12
          )?.toFixed(2)
        );
        if (rowIndex >= 1) {
          if (updatedRowData[rowIndex].purchasedFinancial > 0) {
            updatedRowData[rowIndex].vehicleEquity =
              removeCommaAndRemoveCurrency(
                updatedRowData[rowIndex].potentialVehicleEquity
              );
          } else {
            updatedRowData[rowIndex].vehicleEquity = 0;
          }
        }
      }
      updatedRowData[rowIndex].fleetSpeed =
        updatedRowData[rowIndex].cashOutlay +
        updatedRowData[rowIndex].fuel +
        updatedRowData[rowIndex].maintenance +
        updatedRowData[rowIndex].cyclingPayment +
        updatedRowData[rowIndex].currentPayment;
      updatedRowData[rowIndex].savings =
        updatedRowData[0].fleetSpeed -
        updatedRowData[rowIndex].fleetSpeed +
        updatedRowData[rowIndex].vehicleEquity;
    } else if (event.colDef.field == "cashOutlay") {
      updatedRowData[rowIndex].fleetSpeed =
        updatedRowData[rowIndex].cashOutlay +
        updatedRowData[rowIndex].fuel +
        updatedRowData[rowIndex].maintenance +
        updatedRowData[rowIndex].cyclingPayment +
        updatedRowData[rowIndex].currentPayment;
      updatedRowData[rowIndex].savings =
        updatedRowData[0].fleetSpeed -
        updatedRowData[rowIndex].fleetSpeed +
        updatedRowData[rowIndex].vehicleEquity;
    } else if (event.colDef.field == "currentPayment") {
      updatedRowData[rowIndex].fleetSpeed =
        updatedRowData[rowIndex].cashOutlay +
        updatedRowData[rowIndex].fuel +
        updatedRowData[rowIndex].maintenance +
        updatedRowData[rowIndex].cyclingPayment +
        updatedRowData[rowIndex].currentPayment;
      updatedRowData[rowIndex].savings =
        updatedRowData[0].fleetSpeed -
        updatedRowData[rowIndex].fleetSpeed +
        updatedRowData[rowIndex].vehicleEquity;
    } else if (event.colDef.field == "annualNeeds") {
      updatedRowData[rowIndex].purchasedFinancial =
        updatedRowData[rowIndex].purchasedFinancial;
      updatedRowData[rowIndex].cashOutlay =
        reportDataFleet?.avgNewVehiclePrice?.toFixed(2) *
        updatedRowData[rowIndex].purchasedFinancial;
      if (rowIndex !== 0) {
        updatedRowData[rowIndex].cyclingPayment = parseFloat(
          (
            cyclingComparision?.monthlyLeaseCost?.toFixed(2) *
            updatedRowData[rowIndex].purchasedFinancial *
            12
          )?.toFixed(2)
        );
        if (rowIndex >= 1) {
          if (updatedRowData[rowIndex].purchasedFinancial > 0) {
            updatedRowData[rowIndex].vehicleEquity =
              removeCommaAndRemoveCurrency(
                updatedRowData[rowIndex].potentialVehicleEquity
              );
          } else {
            updatedRowData[rowIndex].vehicleEquity = 0;
          }
        }
      }
      updatedRowData[rowIndex].fleetSpeed =
        updatedRowData[rowIndex].cashOutlay +
        updatedRowData[rowIndex].fuel +
        updatedRowData[rowIndex].maintenance +
        updatedRowData[rowIndex].cyclingPayment +
        updatedRowData[rowIndex].currentPayment;
      updatedRowData[rowIndex].savings =
        updatedRowData[0].fleetSpeed -
        updatedRowData[rowIndex].fleetSpeed +
        updatedRowData[rowIndex].vehicleEquity;
    } else if (event.colDef.field == "vehicleEquity") {
      if (rowIndex >= 1) {
        updatedRowData[rowIndex].potentialVehicleEquity =
          updatedRowData[rowIndex].vehicleEquity;
      }
      updatedRowData[rowIndex].savings =
        updatedRowData[0].fleetSpeed -
        updatedRowData[rowIndex].fleetSpeed +
        updatedRowData[rowIndex].vehicleEquity;
    }
    setRowData(updatedRowData);
    newData(updatedRowData);
    setLoadingGrid(true);
    calculateTotalSavings(updatedRowData);
  };

  const handleSave = async (value) => {
    let reportDataStr = reportDataFinal?.reportData || state?.data?.reportData;
    let reportData = reportDataStr ? JSON.parse(reportDataStr) : {};
    let cyclingComparisionValue = {
      ...cyclingComparision,
      proposedCycle: proposedCycle,
    };
    let resultData = JSON.stringify({
      fleet: reportDataFleet || reportData?.fleet,
      maintainanceCost: maintananceCost || reportData?.maintainanceCost,
      fuelCost: fuelCost || reportData?.fuelCost,
      cyclingComparision: cyclingComparisionValue,
      fleetMix: rowData,
    });
    let payload = {
      reportData: resultData,
      companyId: companyId,
      createdBy: Number(localStorage.getItem("cashflow_admin_user_id")),
      id: reportDataFinal?.id || state?.data?.id,
      reportName: reportDataFinal?.reportName || state?.data?.reportName,
      createdAt: moment().format(),
    };
    if (value) {
      await updateViewAnalysisResult(payload);
    } else {
      await updateAnalysisResult(payload);
    }
  };

  const handleCompanyChangeSave = async (value) => {
    let reportDataStr = reportDataFinal?.reportData || state?.data?.reportData;
    let reportData = reportDataStr ? JSON.parse(reportDataStr) : {};
    let cyclingComparisionValue = {
      ...cyclingComparision,
      proposedCycle: proposedCycle,
    };
    let resultData = JSON.stringify({
      fleet: reportDataFleet || reportData?.fleet,
      maintainanceCost: maintananceCost || reportData?.maintainanceCost,
      fuelCost: fuelCost || reportData?.fuelCost,
      cyclingComparision: cyclingComparisionValue,
      fleetMix: rowData,
    });
    let payload = {
      reportData: resultData,
      companyId: companyId,
      createdBy: Number(localStorage.getItem("cashflow_admin_user_id")),
      id: reportDataFinal?.id || state?.data?.id,
      reportName: reportDataFinal?.reportName || state?.data?.reportName,
      createdAt: moment().format(),
      companyName: companyNameHeader,
      companyNameNew: analysisCompanyChange,
      dealerName: analysisDealerChange,
    };
    await updateAnalysisCompanyResult(payload);
    setSelectedNav(sidebarMenu.dashboard);
    navigation("/dashboard");
  };

  const handleCreateFleet = () => {
    navigation("/current-fleet-details");
  };

  const handlePowerBiReport = async () => {
    // navigation("/reports?id=" + state.data.id);
    await handleSave(true);
    navigation("/reports", { state: { id: state?.data?.id } });
    setSelectedNav(sidebarMenu.reports);
  };

  const handleProposedCycleChange = (e) => {
    let data = Number(e.target.value);
    if (!e.target.value) {
      setProposedCycle();
      if (timeoutId) {
        clearTimeout(timeoutId);
        setTimeoutId(null);
      }
      return;
    }
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    setProposedCycle(data);
    const newTimeoutId = setTimeout(() => {
      if (data > 5) {
        setProposedCycle(5);
      } else if (data < 0 || data === 0) {
        setProposedCycle(1);
      } else {
        setProposedCycle(data);
      }
      setTimeoutId(null);
    }, 500);
    setTimeoutId(newTimeoutId);
  };
  const gridRef = useRef(null);

  useEffect(() => {
    const appendTotalSavings = () => {
      const paginationPanel = document.querySelector(".ag-paging-panel");
      if (paginationPanel) {
        let totalSavingsDiv = document.querySelector(".custom-total-savings");
        if (!totalSavingsDiv) {
          totalSavingsDiv = document.createElement("div");
          totalSavingsDiv.className = `${classes.analysisTotalSavingButton} custom-total-savings`;
          paginationPanel.appendChild(totalSavingsDiv);
        }
        totalSavingsDiv.innerHTML = `<div class="${classes.totalSavingText
          }"></div>`;
      }
    };

    if (!loading && gridRef?.current) {
      setTimeout(() => {
        appendTotalSavings();
      }, 1000);
    }
  }, [totalSavings, classes, gridRef, loading]);

  useEffect(() => {
    setAnalysisResultId(null);
  }, []);

  const handleAnalysisSave = async () => {
    if (analysisCompanyChange) {
      setAnalysisCompanyDefaultNameChange(analysisCompanyChange);
    }
    if (analysisDealerChange) {
      setAnalysisCompanyDefaultNameChange(null);
      setAnalysisDealerDefaultNameChange(analysisDealerChange);
    }
    setLoadingDilogBoxSave(false);
    await handleCompanyChangeSave();
    setPopupOpen(false);
  };
  const handleAnalysisClose = () => {
    setAnalysisDealerChange(null);
    setAnalysisCompanyDefaultNameChange(companyNameHeader);
    setAnalysisDealerDefaultNameChange(dealerNameHeader);
    setPopupOpen(false);
  };

  return (
    <Box className={classes.mainAnalysisContent}>
      <Box style={{ marginBottom: "40px" }}>
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className={classes.headerAnalysisReport}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
              p: "14px 20px",
              background: "var(--surface)",
              border: "1px solid var(--divider)",
              borderRadius: "16px",
              boxShadow: "0 2px 12px rgba(8,96,211,0.06)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Assessment sx={{ color: "var(--brand-primary)", fontSize: 24 }} />
              <span style={{ fontSize: 16, fontWeight: 800, color: "var(--text-primary)", letterSpacing: "0.5px" }}>
                CURRENT SITUATION
              </span>
            </Box>
            <Box sx={{ display: "flex", gap: 1.5 }}>
              <Button
                variant="outlined"
                startIcon={<Add />}
                onClick={handleCreateFleet}
                sx={{
                  borderColor: "var(--divider)", color: "var(--text-primary)", borderRadius: "10px",
                  textTransform: "none", fontWeight: 600,
                  "&:hover": { borderColor: "var(--brand-primary)", color: "var(--brand-primary)", background: "rgba(8,96,211,0.06)" }
                }}
              >
                Create
              </Button>
              <Button
                variant="outlined"
                startIcon={<Assessment />}
                onClick={handlePowerBiReport}
                sx={{
                  borderColor: "var(--divider)", color: "var(--text-primary)", borderRadius: "10px",
                  textTransform: "none", fontWeight: 600,
                  "&:hover": { borderColor: "var(--brand-primary)", color: "var(--brand-primary)", background: "rgba(8,96,211,0.06)" }
                }}
              >
                View Report
              </Button>
              <>
                <Button
                  variant="contained"
                  endIcon={<KeyboardArrowDownIcon />}
                  onClick={handleOpen}
                  sx={{
                    background: "var(--brand-primary)",
                    color: "#fff",
                    borderRadius: "10px",
                    textTransform: "none",
                    fontWeight: 700,
                    minWidth: 150,
                    boxShadow: "0 4px 12px rgba(8,96,211,0.25)",
                    "&:hover": {
                      background: "var(--brand-primary-hover)",
                    },
                  }}
                >
                  Export
                </Button>

                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  PaperProps={{
                    elevation: 4,
                    sx: {
                      mt: 1,
                      borderRadius: 2,
                      minWidth: 220,
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      handleExportButton(reportDataFinal);
                    }}
                  >
                    <ListItemIcon>
                      <TableViewIcon fontSize="small" color="success" />
                    </ListItemIcon>

                    <ListItemText>Export Excel (.xlsx)</ListItemText>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      handleClose();
                      handleExportToCSV(reportDataFinal);
                    }}
                  >
                    <ListItemIcon>
                      <GridOnIcon fontSize="small" color="primary" />
                    </ListItemIcon>

                    <ListItemText>Export CSV</ListItemText>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      handleClose();
                      handleExportToPPT(reportDataFinal);
                    }}
                  >
                    <ListItemIcon>
                      <SlideshowIcon fontSize="small" color="warning" />
                    </ListItemIcon>

                    <ListItemText>Export PowerPoint (.pptx)</ListItemText>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      handleClose();
                      handleExportToPDF(reportDataFinal);
                    }}
                  >
                    <ListItemIcon>
                      <PictureAsPdfIcon fontSize="small" color="error" />
                    </ListItemIcon>

                    <ListItemText>Export PDF</ListItemText>
                  </MenuItem>
                </Menu>
              </>
            </Box>
          </Grid>
          {/* Card 1: Fleet */}
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <PremiumCard title="FLEET" icon={<DirectionsCar sx={{ color: "var(--brand-primary)", fontSize: 20 }} />}>
              <MetricRow label="Current Fleet Size" value={reportDataFleet?.currentFleetSize} />
              <MetricRow label="Avg. Vehicle Model Age" value={reportDataFleet?.avgVehicleYear} />
              <MetricRow label="Avg New Vehicle Price" value={getCurrencyValue(reportDataFleet?.avgNewVehiclePrice)} />
              <MetricRow label="Avg. Current Mileage" value={addComma(Math.round(reportDataFleet?.currentMileage))} />
              <MetricRow label="Current Cycle (Years)" value={reportDataFleet?.currentCycle} />
              <MetricRow label="Avg. Annual Miles" value={addComma(Math.round(reportDataFleet?.annualMiles))} />
            </PremiumCard>
          </Grid>

          {/* Card 2: Maintenance Cost */}
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <PremiumCard title="MAINTENANCE COST" icon={<Build sx={{ color: "var(--brand-primary)", fontSize: 20 }} />}>
              <MetricRow label="Total Annualized Spend" value={getCurrencyValue(maintananceCost?.totalAnnualized)} />
              <MetricRow label="Per Vehicle Spend" value={getCurrencyValue(maintananceCost?.vehicleSpend)} />
              <MetricRow label="Vehicle Spend/Month" value={getCurrencyValue(maintananceCost?.vehicleSpendMonth)} />
              <MetricRow label="Avg. Cost per Mile/Vehicle" value={maintananceCost?.costPerMile ? getCurrencyValue(Number(maintananceCost?.costPerMile)) : 0} />
            </PremiumCard>
          </Grid>

          {/* Card 3: Fuel Cost */}
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <PremiumCard title="FUEL COST" icon={<LocalGasStation sx={{ color: "var(--brand-primary)", fontSize: 20 }} />}>
              <MetricRow label="Avg. MPG" value={fuelCost?.avgMpg?.toFixed(2)} />
              <MetricRow label="Avg. Annual Miles" value={addComma(Math.round(fuelCost?.avgAnnualMiles))} />
              <MetricRow label="Number of Vehicles" value={reportDataFleet?.currentFleetSize} />
              <MetricRow label="Avg. Cost per Gallon" value={getCurrencyValue(fuelCost?.costPerGallon)} />
              <MetricRow label="Total Fuel Spend" value={getCurrencyValue(fuelCost?.totalFuelSpend)} />
              <MetricRow label="Annual Spend/Vehicle" value={getCurrencyValue(fuelCost?.annualSpendVehicle)} />
              <MetricRow label="Monthly Spend/Vehicle" value={getCurrencyValue(fuelCost?.monthlySpendVehicle)} />
            </PremiumCard>
          </Grid>

          {/* Card 4: Cycling Comparisons */}
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <PremiumCard title="CYCLING COMPARISONS" icon={<Sync sx={{ color: "var(--brand-primary)", fontSize: 20 }} />}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px dashed var(--divider)", pb: 1 }}>
                <span style={{ fontSize: 12, fontWeight: 500, color: "var(--text-secondary)" }}>Proposed Cycle (Years)</span>
                <TextField
                  variant="standard"
                  size="small"
                  type="number"
                  value={proposedCycle}
                  sx={{ width: 60, input: { textAlign: "right", fontSize: 13, fontWeight: 700, color: "var(--brand-primary)" } }}
                  {...register("proposedCycle")}
                  onChange={handleProposedCycleChange}
                />
              </Box>
              <MetricRow label="Monthly Lease Cost Avg" value={getCurrencyValue(cyclingComparision?.monthlyLeaseCost)} />
              <MetricRow label="Average Year 1 MPG" value={cyclingComparision?.avgYear1Mpg?.toFixed(2)} />
              <MetricRow label="Y1 Fuel Spend/Vehicle" value={getCurrencyValue(cyclingComparision?.fuelSpendY1)} />
              <MetricRow label="Year 1 Monthly Maintenance" value={getCurrencyValue(cyclingComparision?.monthlyMaintananceYear1)} />
              <MetricRow label="Y1 Average Cost Per Mile" value={getCurrencyValue(cyclingComparision?.avgYear1CostPerMiles)} />
            </PremiumCard>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box sx={{
              background: "var(--surface)",
              border: "1px solid var(--divider)",
              borderRadius: "16px",
              boxShadow: "0 4px 16px rgba(8,96,211,0.06)",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "16px 20px",
                  borderBottom: "1px solid var(--divider)",
                  background: "rgba(8,96,211,0.02)"
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Assessment sx={{ color: "var(--brand-primary)", fontSize: 20 }} />
                  <span style={{ fontSize: 14, fontWeight: 800, color: "var(--text-primary)", letterSpacing: "0.5px" }}>FLEET MIX</span>
                </Box>
                <Box style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  {/* Total Savings Badge (Dynamic Red/Green) */}
                  <Box sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "6px 16px",
                    borderRadius: "20px",
                    background: totalSavings >= 0 ? "linear-gradient(135deg, #16a34a 0%, #22c55e 100%)" : "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
                    boxShadow: totalSavings >= 0 ? "0 4px 12px rgba(34, 197, 94, 0.3)" : "0 4px 12px rgba(239, 68, 68, 0.3)",
                    border: "1px solid rgba(255,255,255,0.2)",
                  }}>
                    <span style={{ fontSize: "12px", fontWeight: 600, color: "rgba(255,255,255,0.9)", letterSpacing: "0.3px" }}>Total Savings:&nbsp;</span>
                    <span style={{ fontSize: "14px", fontWeight: 800, color: "#fff", letterSpacing: "0.5px" }}>{getCurrencyValue(totalSavings)}</span>
                  </Box>
                  <Button
                    variant="contained"
                    onClick={handleSave}
                    sx={{
                      background: "var(--brand-primary)", color: "white", borderRadius: "10px",
                      textTransform: "none", fontWeight: 700, px: 3, boxShadow: "0 4px 12px rgba(8,96,211,0.25)",
                      "&:hover": { background: "var(--brand-primary-hover)", transform: "translateY(-1px)", boxShadow: "0 6px 16px rgba(8,96,211,0.35)" }
                    }}
                  >
                    Save
                  </Button>
                </Box>
              </Box>
              <Box sx={{ p: 2 }}>
                {loading ? (
                  <TruckLoader />
                ) : (
                  <div className="premium-grid-wrapper">
                    <AgGridReact
                      key={"ag-grid-reports"}
                      className="ag-theme-quartz ag-analysis-grid"
                      domLayout="autoHeight"
                      rowSelection="multiple"
                      suppressRowClickSelection
                      ref={gridRef}
                      pinnedColumns={{ right: ["action"] }}
                      pagination={true}
                      rowData={rowData}
                      onCellValueChanged={handleCellValueChange}
                      defaultColDef={defaultColDef}
                      columnDefs={ensureHeaderTooltip(analysisReportColumnData)}
                    />
                  </div>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {popupOpen && (
        <ConfirmAnalysisResultDialog
          open={popupOpen}
          setOpen={() => setPopupOpen(false)}
          handleSave={handleAnalysisSave}
          loading={loadingDilogBoxSave}
          setLoading={setLoadingDilogBoxSave}
          companyNameHeader={companyNameHeader}
          setAnalysisCompanyDefaultNameChange={
            setAnalysisCompanyDefaultNameChange
          }
          setAnalysisDealerDefaultNameChange={
            setAnalysisDealerDefaultNameChange
          }
          dealerNameHeader={dealerNameHeader}
          handleClose={handleAnalysisClose}
        />
      )}
    </Box>
  );
};
